import { CustomCellRendererProps } from 'ag-grid-react'

import { useInvestmentBucketsQuery } from '@/react-query/queries/static'

export interface InvestmentBucketIdCellRendererProps extends CustomCellRendererProps {}

export const InvestmentBucketIdCellRenderer: React.FC<InvestmentBucketIdCellRendererProps> = ({
  value,
}) => {
  const query = useInvestmentBucketsQuery()

  const label = value ? (query.data?.find((c) => c.value == value)?.label ?? value) : null

  return <>{label}</>
}
